var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministratorreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#ED7309"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#333",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67 12l-.386-1.472H6.732L6.335 12H4.004l2.562-7.885h2.83L11.991 12H9.67zm-.827-3.212L8.505 7.5l-.156-.596c-.068-.262-.136-.53-.204-.806-.064-.28-.115-.508-.15-.687-.033.179-.08.4-.14.666-.057.261-.118.52-.183.778-.06.258-.114.473-.16.645l-.34 1.29h1.671z",
    fill: "#fff"
  })));
}
export default SvgAdministratorreact;